import { render } from "./BuyASubscriptionWarningModal.vue?vue&type=template&id=30842c90&scoped=true"
import script from "./BuyASubscriptionWarningModal.vue?vue&type=script&lang=js"
export * from "./BuyASubscriptionWarningModal.vue?vue&type=script&lang=js"

import "./BuyASubscriptionWarningModal.vue?vue&type=style&index=0&id=30842c90&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30842c90"]])

export default __exports__